import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withKeys as _withKeys, withModifiers as _withModifiers, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06e26159"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "data-bs-Toggle": "modal",
  "data-bs-target": "#modalEdit"
}, null, -1))
const _hoisted_2 = {
  class: "modal fade",
  id: "modalEdit",
  tabindex: "-1",
  "aria-labelledby": "editPost",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title text-center fw-bold w-100",
  id: "staticBackdropLabel"
}
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "mb-4" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "fw-bold col-form-label me-2" }
const _hoisted_14 = { class: "text-danger fs-7" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_17 = { class: "mb-4" }
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_19 = { class: "d-flex align-items-center" }
const _hoisted_20 = { class: "fw-bold col-form-label me-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode()
const _hoisted_22 = { class: "text-danger fs-7" }
const _hoisted_23 = { class: "position-relative mb-2" }
const _hoisted_24 = ["placeholder"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-paperclip" }, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_28 = { class: "mb-0 fw-bold fs-7" }
const _hoisted_29 = { class: "fw-bold fs-7" }
const _hoisted_30 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_31 = {
  key: 1,
  class: "d-flex mb-3 m-2 justify-content-center"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 2,
  class: "d-flex"
}
const _hoisted_36 = { class: "me-2 text-truncate" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 3,
  class: "d-flex m-2 justify-content-center"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  key: 1,
  class: "me-2 text-truncate"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = {
  key: 4,
  class: "invalid-error mar-bot-15"
}
const _hoisted_46 = {
  key: 1,
  class: "invalid-error mar-bot-15"
}
const _hoisted_47 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = { class: "fw-bold col-form-label me-2" }
const _hoisted_50 = { class: "mt-2 d-flex align-items-center justify-content-between" }
const _hoisted_51 = { class: "d-flex align-items-center" }
const _hoisted_52 = { class: "fw-bold col-form-label me-2" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 2,
  class: "invalid-error"
}
const _hoisted_55 = {
  key: 3,
  class: "invalid-error"
}
const _hoisted_56 = {
  key: 4,
  class: "invalid-feedback d-block"
}
const _hoisted_57 = {
  key: 5,
  class: "invalid-feedback d-block"
}
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "row mb-4 border-bottom-post" }
const _hoisted_60 = { class: "mar-bot-15 fw-bold" }
const _hoisted_61 = { class: "col-md-12" }
const _hoisted_62 = { class: "row mb-4 border-bottom-post" }
const _hoisted_63 = { class: "mar-bot-15 fw-bold" }
const _hoisted_64 = { class: "col-md-12 break-spaces text-break" }
const _hoisted_65 = {
  key: 0,
  class: "row mb-4 border-bottom-post"
}
const _hoisted_66 = { class: "text-center" }
const _hoisted_67 = ["src"]
const _hoisted_68 = {
  key: 1,
  class: "row mb-4 border-bottom-post mt-n4 py-0 url-container"
}
const _hoisted_69 = {
  key: 2,
  class: "row mb-4 border-bottom-post"
}
const _hoisted_70 = { class: "col-md-12 text-truncate" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_72 = { class: "row mb-4 border-bottom-post" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "タグ", -1))
const _hoisted_74 = { class: "d-flex flex-wrap" }
const _hoisted_75 = { class: "row d-flex mb-3" }
const _hoisted_76 = { class: "col-3" }
const _hoisted_77 = { class: "col-9 d-flex flex-wrap" }
const _hoisted_78 = { class: "me-2 d-flex align-items-center" }
const _hoisted_79 = { class: "me-2" }
const _hoisted_80 = { class: "d-flex mb-3 row" }
const _hoisted_81 = { class: "col-3" }
const _hoisted_82 = { class: "col-9 d-flex" }
const _hoisted_83 = { class: "form-check me-2" }
const _hoisted_84 = {
  class: "form-check-label",
  for: "flexRadioDefault1"
}
const _hoisted_85 = { class: "form-check" }
const _hoisted_86 = {
  class: "form-check-label",
  for: "flexRadioDefault2"
}
const _hoisted_87 = { class: "modal-footer justify-content-center" }
const _hoisted_88 = {
  class: "modal fade",
  id: "modalBeforeEdit",
  tabindex: "-1",
  "aria-labelledby": "beforeEditPost",
  "aria-hidden": "true"
}
const _hoisted_89 = { class: "modal-dialog" }
const _hoisted_90 = { class: "modal-content" }
const _hoisted_91 = { class: "modal-header" }
const _hoisted_92 = {
  class: "modal-title text-center fw-bold w-100",
  id: "staticBackdropLabel"
}
const _hoisted_93 = { class: "modal-body p-3 w-100 mx-lg-auto mx-1" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { class: "row mb-4 border-bottom-post" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "投稿のタイプ", -1))
const _hoisted_97 = { class: "col-md-12" }
const _hoisted_98 = {
  key: 0,
  class: "break-word",
  style: {"width":"80%"}
}
const _hoisted_99 = { class: "row mb-4 border-bottom-post" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "タイトル", -1))
const _hoisted_101 = { class: "col-md-12" }
const _hoisted_102 = { class: "row mb-4 border-bottom-post" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "本文", -1))
const _hoisted_104 = { class: "col-md-12 break-spaces text-break" }
const _hoisted_105 = {
  key: 0,
  class: "row mb-4 border-bottom-post text-center"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "添付ファイル", -1))
const _hoisted_107 = { class: "text-center" }
const _hoisted_108 = ["src"]
const _hoisted_109 = {
  key: 1,
  class: "row mb-4 border-bottom-post"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "添付ファイル", -1))
const _hoisted_111 = { class: "col-md-12 text-truncate" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-file-pdf me-2" }, null, -1))
const _hoisted_113 = {
  key: 2,
  class: "row mb-4 border-bottom-post mt-n4 py-0 url-container"
}
const _hoisted_114 = { class: "row mb-4 border-bottom-post" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "タグ", -1))
const _hoisted_116 = { class: "d-flex flex-wrap" }
const _hoisted_117 = { class: "row mb-4 mar-top-2r" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "公開設定", -1))
const _hoisted_119 = { class: "col-md-12 break-spaces text-break" }
const _hoisted_120 = {
  key: 1,
  class: "mar-top-2r"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"center"} }, "公開設定を更新します。", -1))
const _hoisted_122 = { class: "mb-4 mar-top-2r d-flex justify-content-center" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mar-bot-15 fw-bold" }, "公開設定", -1))
const _hoisted_124 = { style: {"margin-left":"5rem"} }
const _hoisted_125 = { class: "modal-footer justify-content-center" }
const _hoisted_126 = {
  class: "modal fade",
  id: "modalEditSuccessOrFailed",
  tabindex: "-1",
  "aria-labelledby": "editPost",
  "aria-hidden": "true"
}
const _hoisted_127 = { class: "modal-dialog" }
const _hoisted_128 = { class: "modal-content" }
const _hoisted_129 = { class: "modal-header" }
const _hoisted_130 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_131 = {
  key: 0,
  class: "modal-body border-bottom-post-confirm mar-bot-15"
}
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "更新しました。", -1))
const _hoisted_133 = {
  key: 0,
  class: "confirmCreateText"
}
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "画像などの添付ファイルはウィルスチェックに", -1))
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "時間がかかる場合があります。", -1))
const _hoisted_137 = [
  _hoisted_134,
  _hoisted_135,
  _hoisted_136
]
const _hoisted_138 = {
  key: 1,
  class: "modal-body border-bottom-post-confirm mar-bot-15"
}
const _hoisted_139 = { class: "text-center" }
const _hoisted_140 = {
  key: 2,
  class: "modal-body border-bottom-post-confirm mar-bot-15"
}
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "更新失敗しました。", -1))
const _hoisted_142 = [
  _hoisted_141
]
const _hoisted_143 = { class: "d-flex align-items-center justify-content-center pb-4" }

import HashTag from '@/components/hash-tag/index.vue'
import Button from '@/components/button/index.vue'
import { computed, ref, watch, onMounted, nextTick } from 'vue'
import { translate } from '@/languages/i18n'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import Status from '@/components/status/index.vue'

//validate
import useVuelidate from '@vuelidate/core'
import { required, minLength } from '@vuelidate/validators'
import { DEFAULT_MIN_LENGTH, MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_FILE_SIZE_BYTES, MAX_LENGTH_POST_CONTENT } from '@/constants/number'
import PostType from '@/views/user/community/home/index.vue'

import { cloneDeep, debounce, isEmpty, omit, uniqBy } from 'lodash'
import { useStore } from 'vuex'
import { USER_POST_STORE } from '@/store/constants'
import { buildFormData, buildImgUrl, countCharInSurrogatePair, customMaxLength, customMinLength, handleBlurInput, scrollToErrors } from '@/utils'
import { addPostParams } from '@/use/usePath'
import { imgTypes } from '@/constants/upload-type'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { REGEX_EMOJI } from '@/constants/regex'
import { useRoute } from 'vue-router'
import userPostService from '@/services/user-post.services'
import commonService from '@/services/common.service'
import { ReplayName } from '@/constants/common'
import { Modal } from 'bootstrap'
import { postMessageByCode } from '@/constants/messageCode'
import UrlInput from '@/components/post-url/UrlInput.vue'
import { validateUrlRulesSF10, VALIDATOR_CONTAIN_NG_WORD } from '@/constants/validate'
import UrlDisplay from '@/components/post-url/UrlDisplay.vue'

type TAG = { id: number; name: string }


export default /*#__PURE__*/_defineComponent({
  props: {
  post: {
    type: Object as PostType,
  },
  hasThreeTabs: Boolean,
  userPost: Boolean,
  count: Number,
  //2022/11/14 TienNV Fix for UAT#5121: CT10, OF10 (Ph2-R20221116)
  modalEdit: Object,
},
  setup(__props) {

const props = __props

const modalConfirm = ref()
const modalFinish = ref()

onMounted(() => {
  modalConfirm.value = new Modal(document.getElementById('modalBeforeEdit'))
  modalFinish.value = new Modal(document.getElementById('modalEditSuccessOrFailed'))
})



const store = useStore()
const inputRef = ref<HTMLElement | null>(null)

const uploadImgStatus = ref<boolean>(false)

const file = ref(null)
const fileData = ref(null)
const fileUrl = ref(null)
const fileName = ref<string>(null)
const fileType = ref<string>(null)

/**
 * Combine with existed validation from v$ rules
 * update value after field blurred.
 */
const $externalResults = ref()

const MAX_LENGTH_TITLE = 30
const MAX_LENGTH_TEXT = MAX_LENGTH_POST_CONTENT

const publish = ref(cloneDeep(props.post?.published))
const errorUpload = ref(false)
const updateFailed = ref<string>(null)
const MaxUploadFileSize = ref(false)

const tags = ref<Array<any>>(cloneDeep(props.post?.tags) ?? [])
const formData = ref({
  ...cloneDeep(props.post),
  file: '',
})
const content_type = ref<number>(1)
watch(
  () => [props.post, props.count],
  () => {
    tags.value = cloneDeep(props.post?.tags)
    formData.value = {
      ...cloneDeep(props.post),
      file: '',
    }
    deleteTags.value = []
    fileUrl.value = cloneDeep(props.post?.image_url) ? cloneDeep(props.post?.image_url) : cloneDeep(props.post?.file_url)
    publish.value = cloneDeep(props.post?.published)
    content_type.value = cloneDeep(props.post?.content_type)
    fileName.value = null
    errorUpload.value = false
  },
  { deep: true }
)

const tag = ref<Pick<TAG, 'name'>>('')

const deleteTags = ref<Array<any>>([])

// 2022/09/21 CW-TrungNT Fix for UAT#4415: CT10 (Ph2-R20220922)
const postFailedMessageCode = ref(null)
const duplicateTags = ref<boolean>(false)

watch(
  () => formData.value?.file,
  () => {
    if (formData.value?.file && formData.value?.file.size > MAX_UPLOAD_FILE_SIZE_BYTES) {
      MaxUploadFileSize.value = true
    } else {
      MaxUploadFileSize.value = false
    }
  }
)

// 2022/09/21 CW-TrungNT Fix for UAT#4415: CT10 (Ph2-R20220922)
watch(
  () => tags.value,
  () => {
    tag.value = null
    //2022/11/12 TienNV Fix for UAT#5121: CT10,OF10 (Ph2-R20221116)
    if (uniqBy(tags.value, 'name').length !== tags.value?.length) {
      duplicateTags.value = true
    } else {
      duplicateTags.value = false
    }
  },
  { immediate: true, deep: true }
)

const checkTags = ref<boolean>(false)
const checkNgTags = async (): Promise<void> => {
  if (tags.value.length === 0) {
    checkTags.value = false
    emojiTag.value = false
    return
  }
  const tagData = tags.value.map((e: TAG) => e.name).join(', ')
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(tagData)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck({ sentence: tagData })
      checkTags.value = data.data.data.has_ngword
    }
  } catch (error) {
    console.log(error)
  }
}

const createTag = async (): Promise<void> => {
  if (!tag.value || tags.value.length === 5) return
  isCheckedNGKeyTag.value = false
  await checkNGKeyTag(tag.value)
  while (!isCheckedNGKeyTag.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }
  if (emojiTag.value) return
  if (ngKeyTag.value) return
  const trimmedArray = tag.value.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if (tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      tags.value.push({
        id: `new-${Date.now()}${tags.value?.length}`,
        name: trimmedString,
      })
    }
  })

  tag.value = ''
  if (tags.value?.length < 5) {
    inputRef.value?.focus()
  }
}

const removeTag = async (id: number): Promise<void> => {
  tags.value = tags.value.filter((e: TAG) => e.id !== id)
  let removeTag = formData.value?.tags.find((e) => e.id === id)
  if (formData.value?.tags.length > 0 && removeTag) {
    deleteTags.value.push({
      ...removeTag,
      _destroy: 1,
    })
  }
  await checkNgTags()
}

const editTag = async (id: number, name: string): Promise<void> => {
  inputRef.value?.focus()

  const trimmedArray = name.replace(/\s+/g, ' ').split(' ')
  trimmedArray.forEach((elem: string, index: number) => {
    for (let i = 0; i < elem.length; i = i + 20) {
      if ((index || (!index && i)) && tags.value?.length === 5) break
      let trimmedString = elem.substring(i, i + 20)

      if (!index && !i) {
        tags.value = tags.value.map((e: TAG) => ({
          ...e,
          name: e.id === id ? trimmedString : e.name,
        }))
      } else {
        tags.value.push({
          id: `new-${Date.now()}${tags.value?.length}`,
          name: trimmedString,
        })
      }
    }
  })
  await checkNgTags()
}

const rules = computed(() => {
  return {
    title: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TITLE),
      minLength: minLength(DEFAULT_MIN_LENGTH),
    },
    content: {
      required,
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_TEXT),
      minLength: (value: string) => customMinLength(value, DEFAULT_MIN_LENGTH),
    },
    site_name_1: {},
    site_url_1: {},
    site_name_2: {},
    site_url_2: {},
    ...validateUrlRulesSF10('site_name_1', 'site_url_1', formData),
    ...validateUrlRulesSF10('site_name_2', 'site_url_2', formData),
  }
})

const textCounter = (maxLength: number, currentLength: number): number => {
  return maxLength - currentLength
}

const textTitle = (valueTitle: number): string => {
  if (valueTitle === 1) return '記事'
  if (valueTitle === 2) return '募集'
  if (valueTitle === 3) return '求人'
}

const removeAvatar = (): void => {
  file.value = null
  fileUrl.value = null
  fileName.value = null
  fileType.value = null
  fileData.value = null
  formData.value.file = null
}

const removeCurrentFile = (type: 'file' | 'image' = 'image'): void => {
  formData.value[`${type}_url`] = null
}
const check_error_upload = ref<number>(1)
const handleChangeFile = async () => {
  check_error_upload.value++
  uploadImgStatus.value = true
  if (file.value.files[0]) {
    const { newFileUrl, newFile } = await buildImgUrl(file.value.files[0])
    uploadImgStatus.value = false
    fileUrl.value = newFileUrl

    fileData.value = newFile

    fileType.value = newFile?.type
    fileName.value = newFile?.name
    formData.value.file = file.value.files[0]
  }
  uploadImgStatus.value = false
  const type = formData.value?.file_url ? 'file' : 'image'
  removeCurrentFile(type)
}

watch(
  () => [fileType.value, check_error_upload.value],
  () => {
    if (['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'].includes(fileType.value) || fileType.value === null) {
      v$.value.$invalid = false
      errorUpload.value = false
    } else {
      v$.value.$invalid = true
      errorUpload.value = true
    }
  }
)

const v$ = useVuelidate(rules, formData, { $externalResults })

const onSubmit = async (): void => {
  v$.value.$touch()

  isCheckedNGKeyTitle.value = false
  isCheckedNGKeyContent.value = false

  await checkNGKeyTitle()
  await checkNGKeyContent()

  if (formData.value.site_name_1) await validateUrlNgWord('site_name_1')
  if (formData.value.site_name_2) await validateUrlNgWord('site_name_2')

  while (!isCheckedNGKeyTitle.value || !isCheckedNGKeyContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (
    v$.value.$invalid ||
    ngKeyTitle.value ||
    ngKeyContent.value ||
    checkTags.value ||
    emojiTag.value ||
    ngKeyTag.value ||
    MaxUploadFileSize.value ||
    errorUpload.value ||
    duplicateTags.value
  ) {
    nextTick(() => {
      const elementErrors = document.querySelector('#modalEdit .invalid-feedback')
      const classErrors = elementErrors ? '.invalid-feedback' : '.invalid-error'
      scrollToErrors(classErrors, '#modalEdit')
    })
    return
  }
  //2022/11/14 TienNV Fix for UAT#5121: CT10, OF10 (Ph2-R20221116)
  props.modalEdit?.hide()
  // 2022/11/22 NamPH fix-remove state modal when reopen UAT-5352
  tag.value = ''
  // 2022/11/22 NamPH fix-remove state modal when reopen UAT-5352
  modalConfirm.value?.show()
}

const route = useRoute()
const loadingEdit = ref<boolean>(false)
const editPost = async () => {
  const tagRemoveId = tags.value.map((e) => (e.id.startsWith('new') ? omit(e, 'id') : e))
  const updatePostJson = {
    id: formData.value.id,
    content_type: formData.value.content_type,
    title: formData.value.title,
    content: formData.value.content,
    image_url: formData.value?.image_url,
    file_url: formData.value?.file_url,
    site_name_1: formData.value.site_name_1,
    site_url_1: formData.value.site_url_1,
    site_name_2: formData.value.site_name_2,
    site_url_2: formData.value.site_url_2,
    published: publish.value,
    tags: [...tagRemoveId, ...deleteTags.value],
  }

  const queryData = {
    chatroom_id: route.params.id,
    params: { ...route.query, page_of_number: route.query?.page_of_number || 30 },
    operational_posts: route.path.includes('operational_posts'),
  }

  const updatePost = new FormData()
  buildFormData(updatePost, updatePostJson)

  if (fileData.value) {
    updatePost.append(imgTypes.includes(fileType.value) ? 'image' : 'file', fileData.value)
  } else {
    ;['image_url', 'file_url'].forEach((e) => {
      if (!formData.value[e]) {
        updatePost.append(e.split('_')[0], '')
      }
    })
  }
  loadingEdit.value = true
  try {
    const data = await userPostService.updateUserPosts(updatePost.get('id'), updatePost)
    if (data.status === 200) {
      updateFailed.value = '200'
    } else {
      const messageCode = data?.response?.data?.data[0]?.message_code
      if (messageCode) postFailedMessageCode.value = messageCode
      updateFailed.value = 'error-400'
    }
    if (data.data?.success) {
      store.commit(USER_POST_STORE.MUTATIONS.UPDATE_POST, data.data.data)
      if (queryData.operational_posts) {
        store.dispatch(USER_POST_STORE.ACTIONS.GET_OPERATIONAL_POST, omit(queryData, 'operational_posts'))
      } else {
        store.dispatch(USER_POST_STORE.ACTIONS.GET_POST, omit(queryData, 'operational_posts'))
      }
    }
    loadingEdit.value = false

    modalConfirm.value?.hide()
    modalFinish.value?.show()
    removeAvatar()
  } catch (error) {
    updateFailed.value = 'other'
    loadingEdit.value = false
  }
  //store.dispatch(USER_POST_STORE.ACTIONS.UPDATE_POST, { updatePost, queryData })
}

const reset = (): void => {
  v$.value.$reset()
  formData.value = {
    ...props.post,
    file: '',
  }
  tags.value = cloneDeep(props.post?.tags)
  tag.value = null
  publish.value = props.post?.published
  ngKeyTitle.value = false
  ngKeyContent.value = false
  emojiTag.value = false
  ngKeyTag.value = false
  checkTags.value = false
}

const isCheckedNGKeyTitle = { value: false }
const ngKeyTitle = ref<boolean>(false)
const checkNGKeyTitle = debounce(async () => {
  const queryData = { sentence: v$.value.title.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyTitle.value = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyTitle.value = true
  }
})

const isCheckedNGKeyContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGKeyContent = debounce(async () => {
  const queryData = { sentence: v$.value.content.$model }
  try {
    const data = await commonService.sendNGWordCheck(queryData)
    ngKeyContent.value = data.data.data.has_ngword
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyContent.value = true
  }
})

const isCheckedNGKeyTag = { value: false }
const emojiTag = ref<boolean>(false)
const ngKeyTag = ref<boolean>(false)
const checkNGKeyTag = debounce(async (value: string) => {
  if (!value || tags.value.length === 5) {
    emojiTag.value = false
    ngKeyTag.value = false
    isCheckedNGKeyTag.value = true
    return
  }
  const queryData = { sentence: value }
  try {
    // REGEX_EMOJIは絵文字を含まない場合にTrueとなるので反転する
    emojiTag.value = !REGEX_EMOJI.test(value)
    if (!emojiTag.value) {
      const data = await commonService.sendNGWordCheck(queryData)
      ngKeyTag.value = data.data.data.has_ngword
    } else {
      ngKeyTag.value = false
    }
  } catch (error) {
    console.log(error)
  } finally {
    isCheckedNGKeyTag.value = true
  }
})

watch(
  () => tag.value,
  (newVal: any) => {
    checkNGKeyTag(newVal as string)
  }
)

const focusInputTag = () => {
  if (tags.value.length === 5) return

  inputRef.value?.focus()
}

const showUrlInConfirmDialog = () =>
  !isEmpty(formData.value.site_name_1) || !isEmpty(formData.value.site_url_1) || !isEmpty(formData.value.site_name_2) || !isEmpty(formData.value.site_url_2)

const validateUrlNgWord = async (name: string) => {
  const queryData = { sentence: formData.value[name] }
  const data = await commonService.sendNGWordCheck(queryData)
  const { has_ngword: isNotValid } = data.data.data

  $externalResults.value = { ...$externalResults.value, [name]: isNotValid ? [VALIDATOR_CONTAIN_NG_WORD] : [] }
}

const onInputURL = () => {
  v$.value.site_name_1.$touch()
  v$.value.site_url_1.$touch()
  v$.value.site_name_2.$touch()
  v$.value.site_url_2.$touch()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h5", _hoisted_6, _toDisplayString(textTitle(content_type.value) + 'の編集'), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: reset
            })
          ]),
          _createElementVNode("form", {
            onSubmit: _withModifiers(onSubmit, ["prevent"]),
            class: "w-100 mx-lg-auto mx-1"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (!__props.userPost)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(translate)(`title`)), 1),
                          _createVNode(Status)
                        ]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(textCounter(MAX_LENGTH_TITLE, _unref(countCharInSurrogatePair)(formData.value?.title))), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "title",
                        class: _normalizeClass(['form-control mb-2', ngKeyTitle.value || _unref(v$).title.$error ? 'is-invalid' : '']),
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyTitle) && _unref(checkNGKeyTitle)(...args))),
                        placeholder: _unref(translate)('SD10requireTitle')
                      }, null, 42, _hoisted_15), [
                        [
                          _vModelText,
                          _unref(v$).title.$model,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      (ngKeyTitle.value && !_unref(v$).title.$error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                        : _createCommentVNode("", true),
                      _createVNode(InputErrorMessage, {
                        title: _unref(translate)(`title`),
                        validator: _unref(v$).title.$errors[0]?.$validator,
                        params: [_unref(DEFAULT_MIN_LENGTH), MAX_LENGTH_TITLE]
                      }, null, 8, ["title", "validator", "params"]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(translate)(`content`)), 1),
                            _hoisted_21,
                            _createVNode(Status)
                          ]),
                          _createElementVNode("div", _hoisted_22, _toDisplayString(textCounter(_unref(MAX_LENGTH_TEXT), _unref(countCharInSurrogatePair)(formData.value.content))), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _withDirectives(_createElementVNode("textarea", {
                            name: "content",
                            rows: "5",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                            onBlur: _cache[3] || (_cache[3] = () => (_unref(v$).content.$model = _unref(v$).content.$model.replace(/\n+$/, ''))),
                            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(checkNGKeyContent) && _unref(checkNGKeyContent)(...args))),
                            class: _normalizeClass(['form-control ', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                            placeholder: _unref(translate)('SD10requireText')
                          }, null, 42, _hoisted_24), [
                            [_vModelText, _unref(v$).content.$model]
                          ]),
                          _createElementVNode("label", {
                            class: _normalizeClass(['camera position-absolute cursor-pointer', ngKeyContent.value || _unref(v$).content.$error ? 'camera--err' : '']),
                            for: "imgEdit"
                          }, _hoisted_26, 2),
                          _createElementVNode("input", {
                            type: "file",
                            class: "d-none",
                            id: "imgEdit",
                            accept: "image/png, image/jpeg, image/jpg, application/pdf",
                            ref: (_value, _refs) => {
                              _refs['file'] = _value
                              file.value = _value
                            },
                            onChange: handleChangeFile,
                            onClick: _cache[5] || (_cache[5] = 
                        (event) => {
                          event.target.value = null
                        }
                      )
                          }, null, 544),
                          (ngKeyContent.value && !_unref(v$).content.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                            : _createCommentVNode("", true),
                          _createVNode(InputErrorMessage, {
                            title: 'content',
                            validator: _unref(v$).content.$errors[0]?.$validator,
                            params: [_unref(DEFAULT_MIN_LENGTH), _unref(MAX_LENGTH_TEXT)]
                          }, null, 8, ["validator", "params"])
                        ]),
                        _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(translate)('postImageAnnotation1')), 1),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(translate)('postImageAnnotation2')), 1),
                        (uploadImgStatus.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                          : _createCommentVNode("", true),
                        (formData.value?.image_url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              _createElementVNode("img", {
                                src: _unref(addPostParams)(__props.post?.image_url, content_type.value),
                                alt: "image",
                                class: "me-2 object-fit-contain mw-100"
                              }, null, 8, _hoisted_32),
                              _createElementVNode("div", {
                                class: "close-icon cursor-pointer",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (removeCurrentFile()))
                              }, _hoisted_34)
                            ]))
                          : _createCommentVNode("", true),
                        (formData.value?.file_url)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, _toDisplayString(__props.post?.file_url.split('/').slice(-1)[0]), 1),
                              _createElementVNode("div", {
                                class: "close-icon cursor-pointer",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (removeCurrentFile('file')))
                              }, _hoisted_38)
                            ]))
                          : _createCommentVNode("", true),
                        (fileName.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              (fileType.value.includes('image'))
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: fileUrl.value ? _unref(addPostParams)(fileUrl.value, content_type.value) : undefined,
                                    alt: "image",
                                    class: "me-2 object-fit-contain mw-100"
                                  }, null, 8, _hoisted_40))
                                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _hoisted_42,
                                    _createTextVNode(" " + _toDisplayString(fileName.value), 1)
                                  ])),
                              _createElementVNode("div", {
                                class: "close-icon cursor-pointer",
                                onClick: removeAvatar
                              }, _hoisted_44)
                            ]))
                          : _createCommentVNode("", true),
                        (MaxUploadFileSize.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(_unref(translate)('validateFileSize', '', [_unref(MAX_UPLOAD_FILE_SIZE_MB)])), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (errorUpload.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_unref(translate)('errorFileUpload')), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("label", _hoisted_49, _toDisplayString(_unref(translate)(`CT10url`)), 1)
                        ])
                      ]),
                      _createVNode(UrlInput, {
                        onInput: onInputURL,
                        "site-name-id": "site_name_1",
                        "site-url-id": "site_url_1",
                        "on-field-blur": validateUrlNgWord,
                        "site-url": _unref(v$).site_url_1,
                        "site-name": _unref(v$).site_name_1,
                        "site-name-label": _unref(translate)('CT10siteName1'),
                        "site-url-label": _unref(translate)('CT10siteUrl1')
                      }, null, 8, ["site-url", "site-name", "site-name-label", "site-url-label"]),
                      _createVNode(UrlInput, {
                        onInput: onInputURL,
                        class: "mt-4",
                        "site-name-id": "site_name_2",
                        "site-url-id": "site_url_2",
                        "on-field-blur": validateUrlNgWord,
                        "site-url": _unref(v$).site_url_2,
                        "site-name": _unref(v$).site_name_2,
                        "site-name-label": _unref(translate)('CT10siteName2'),
                        "site-url-label": _unref(translate)('CT10siteUrl2')
                      }, null, 8, ["site-url", "site-name", "site-name-label", "site-url-label"]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(_unref(translate)(`CT10tag`)), 1)
                        ])
                      ]),
                      _createElementVNode("label", {
                        class: "d-flex flex-wrap form-control mb-2",
                        onClick: _withModifiers(focusInputTag, ["self"])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                          return (_openBlock(), _createBlock(HashTag, {
                            tag: tag,
                            key: tag.id,
                            class: "me-2 mb-2",
                            removeTag: () => removeTag(tag.id),
                            onEditTag: editTag,
                            editable: true
                          }, null, 8, ["tag", "removeTag"]))
                        }), 128)),
                        (tags.value?.length < 5)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              ref: (_value, _refs) => {
                                _refs['inputRef'] = _value
                                inputRef.value = _value
                              },
                              type: "text",
                              class: "border-0 input-tag",
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((tag).value = $event)),
                              onKeyup: _cache[9] || (_cache[9] = _withKeys(($event: any) => ($event.target.blur()), ["enter"])),
                              onInput: _cache[10] || (_cache[10] = (eve) => _unref(handleBlurInput)(eve, inputRef.value)),
                              onBlur: createTag
                            }, null, 544)), [
                              [
                                _vModelText,
                                tag.value,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_53),
                      (emojiTag.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_unref(translate)('validateEmoji')), 1))
                        : (ngKeyTag.value || checkTags.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                          : (duplicateTags.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_unref(translate)('VALIDATE_SAME_TAGS')), 1))
                            : _createCommentVNode("", true),
                      (tags.value?.length > 5)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, " ※タグは1つの投稿に5つまで設定できます。 "))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_unref(translate)(`title`)), 1),
                        _createElementVNode("div", _hoisted_61, _toDisplayString(formData.value.title), 1)
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, _toDisplayString(_unref(translate)(`content`)), 1),
                        _createElementVNode("div", _hoisted_64, _toDisplayString(formData.value.content), 1)
                      ]),
                      (__props.post?.image_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _createElementVNode("div", _hoisted_66, [
                              _createElementVNode("img", {
                                src: _unref(addPostParams)(__props.post?.image_url, content_type.value),
                                alt: "image",
                                class: "file-url mh-100"
                              }, null, 8, _hoisted_67)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (showUrlInConfirmDialog())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createVNode(UrlDisplay, {
                              "site-url": formData.value.site_url_1,
                              "site-name": formData.value.site_name_1
                            }, null, 8, ["site-url", "site-name"]),
                            _createVNode(UrlDisplay, {
                              "site-url": formData.value.site_url_2,
                              "site-name": formData.value.site_name_2
                            }, null, 8, ["site-url", "site-name"])
                          ]))
                        : _createCommentVNode("", true),
                      (__props.post?.file_url)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, [
                              _hoisted_71,
                              _createTextVNode(" " + _toDisplayString(__props.post?.file_url.split('/').slice(-1)[0]), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_72, [
                        _hoisted_73,
                        _createElementVNode("div", _hoisted_74, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: "text-break me-2 mb-2",
                              key: tag.id
                            }, _toDisplayString('#' + tag.name), 1))
                          }), 128))
                        ])
                      ])
                    ])),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(translate)('creator')), 1),
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("div", _hoisted_78, [
                      _createVNode(UserAliasIcon, {
                        userType: formData.value.user_type
                      }, null, 8, ["userType"])
                    ]),
                    _createElementVNode("div", _hoisted_79, _toDisplayString(formData.value?.management_no +
                      ' ' +
                      _unref(ReplayName)(formData.value?.is_deleted_in_30_days, formData.value?.available, formData.value?.family_name, formData.value?.given_name, formData.value?.user_type)) + " " + _toDisplayString(formData.value?.user_type == 'alumni' && [0, 1].includes(formData.value?.is_deleted_in_30_days) ? `（ ${formData.value?.display_name} ）` : ''), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, _toDisplayString(_unref(translate)('publicSettings')), 1),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("label", _hoisted_84, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((publish).value = $event)),
                          value: true,
                          type: "radio",
                          name: "flexRadioDefault",
                          id: "flexRadioDefault1"
                        }, null, 512), [
                          [_vModelRadio, publish.value]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_unref(translate)('public')), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createElementVNode("label", _hoisted_86, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((publish).value = $event)),
                          value: false,
                          type: "radio",
                          name: "flexRadioDefault",
                          id: "flexRadioDefault2"
                        }, null, 512), [
                          [_vModelRadio, publish.value]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_unref(translate)('private')), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_87, [
              _createVNode(Button, {
                title: _unref(translate)('cancel'),
                class: "m-w-unset",
                type: 'secondary',
                "data-bs-dismiss": 'modal',
                onClick: reset
              }, null, 8, ["title"]),
              _createVNode(Button, {
                onClick: onSubmit,
                title: _unref(translate)('confirm'),
                class: "m-w-unset",
                type: 'secondary',
                disabled: _unref(v$).$invalid || errorUpload.value || emojiTag.value || ngKeyTag.value || checkTags.value || duplicateTags.value
              }, null, 8, ["title", "disabled"])
            ])
          ], 40, _hoisted_7)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_88, [
      _createElementVNode("div", _hoisted_89, [
        _createElementVNode("div", _hoisted_90, [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("h5", _hoisted_92, _toDisplayString(textTitle(content_type.value) + 'の編集'), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: reset
            })
          ]),
          _createElementVNode("div", _hoisted_93, [
            (!__props.userPost)
              ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _hoisted_96,
                    _createElementVNode("div", _hoisted_97, _toDisplayString(textTitle(content_type.value)), 1),
                    (content_type.value === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(_unref(translate)('postJob')), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _hoisted_100,
                    _createElementVNode("div", _hoisted_101, _toDisplayString(formData.value.title), 1)
                  ]),
                  _createElementVNode("div", _hoisted_102, [
                    _hoisted_103,
                    _createElementVNode("div", _hoisted_104, _toDisplayString(formData.value.content), 1)
                  ]),
                  (formData.value?.image_url || ['image/jpeg', 'image/jpg', 'image/png'].includes(fileType.value))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                        _hoisted_106,
                        _createElementVNode("div", _hoisted_107, [
                          _createElementVNode("img", {
                            src: fileUrl.value ? _unref(addPostParams)(fileUrl.value, content_type.value) : undefined,
                            alt: "image",
                            class: "file-url mh-100"
                          }, null, 8, _hoisted_108)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (formData.value?.file_url || fileType.value === 'application/pdf')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                        _hoisted_110,
                        _createElementVNode("div", _hoisted_111, [
                          _hoisted_112,
                          _createTextVNode(" " + _toDisplayString(formData.value?.file_url ? formData.value?.file_url.split('/').slice(-1)[0] : fileName.value), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (showUrlInConfirmDialog())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
                        _createVNode(UrlDisplay, {
                          "site-url": formData.value.site_url_1,
                          "site-name": formData.value.site_name_1
                        }, null, 8, ["site-url", "site-name"]),
                        _createVNode(UrlDisplay, {
                          "site-url": formData.value.site_url_2,
                          "site-name": formData.value.site_name_2
                        }, null, 8, ["site-url", "site-name"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("div", _hoisted_116, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
                        return (_openBlock(), _createElementBlock("span", {
                          class: "text-break me-2 mb-2",
                          key: tag.id
                        }, _toDisplayString('#' + tag.name), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _hoisted_118,
                    _createElementVNode("div", _hoisted_119, _toDisplayString(publish.value ? '公開' : '非公開'), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_120, [
                  _hoisted_121,
                  _createElementVNode("div", _hoisted_122, [
                    _hoisted_123,
                    _createElementVNode("div", _hoisted_124, _toDisplayString(publish.value ? '公開' : '非公開'), 1)
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_125, [
            _createVNode(Button, {
              title: _unref(translate)('postEdit'),
              class: "m-w-unset",
              type: 'secondary',
              dataBsToggle: 'modal',
              dataBsTarget: '#modalEdit'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              onClick: editPost,
              title: _unref(translate)('postSubmitEdit'),
              class: "m-w-unset",
              type: 'secondary',
              loading: loadingEdit.value,
              disabled: loadingEdit.value
            }, null, 8, ["title", "loading", "disabled"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_126, [
      _createElementVNode("div", _hoisted_127, [
        _createElementVNode("div", _hoisted_128, [
          _createElementVNode("div", _hoisted_129, [
            _createElementVNode("h5", _hoisted_130, _toDisplayString(textTitle(content_type.value) + 'の編集'), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: reset
            })
          ]),
          (updateFailed.value === '200')
            ? (_openBlock(), _createElementBlock("div", _hoisted_131, [
                _hoisted_132,
                (!__props.userPost)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_133, _hoisted_137))
                  : _createCommentVNode("", true)
              ]))
            : (updateFailed.value === 'error-400')
              ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
                  _createElementVNode("p", _hoisted_139, _toDisplayString(_unref(postMessageByCode)(postFailedMessageCode.value) || '投稿の更新に失敗しました。'), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_140, _hoisted_142)),
          _createElementVNode("div", _hoisted_143, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              class: "m-w-unset",
              type: 'secondary',
              "data-bs-dismiss": "modal"
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})